import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { VcsAgentPoolView } from "../../types";

const VCSAgentPoolsTableDescriptionCell = ({
  item: vcsAgentPool,
  ...cellProps
}: TableSimpleCellProps<VcsAgentPoolView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={vcsAgentPool.description} />
    </TableSimpleCell>
  );
};

export default VCSAgentPoolsTableDescriptionCell;
